module.exports = __webpack_public_path__ + "img/banner1.89f723ef.png";